import { removePartnerCustomerAccess } from '../forms/portal-users/form-user-helpers';
import useAuth from '../../hooks/auth-hooks';
import { IAccessList } from '../../models/user.interface';

/**
 * Displays a list of Partner/Customer(s) for the portal user form
 * 
 * @param {object} data list data
 * @param {HTMLElement} container container for the list items
 */

export const displayPartnerCustomerList = (data: IAccessList[], container: HTMLElement) => {  
  data.forEach((value: IAccessList) => {
    const div = document.createElement('div');
    div.className = `list-results-widget key_${value.id}`;        

    const span = document.createElement('span');
    span.textContent = value.name;

    const addButton = document.createElement('a');
    addButton.className = 'aafp_btn-form btn_theme-primary get-selected-element';
    addButton.id = `aafp_add-${value.id}`;
    addButton.textContent = 'ADD';
    addButton.setAttribute(`data-id`, value.id);
    addButton.setAttribute('data-name', value.name);

    div.appendChild(span);
    div.appendChild(addButton);

    if ( data.length > 1 ) {
      container.appendChild(div);  
    } else {
      container.prepend(div);  
    }    
  });

  data.length = 0;
}

/**
 * Displays a list of linked Partner/Customer(s) for the portal user form
 * 
 * @param {HTMLElement} container container for the list items
 * @param {object} data list data
 * 
 * @returns void
 */

export const displayLinkedPartnerCustomer = (container: HTMLElement, data: IAccessList[] ) => {
  const { accessType } = useAuth()!;

  data.forEach((e: IAccessList) => {
    const div = document.createElement('div');
    div.className = `single-row-widget aafp_border-radius linked-element ele_access_${e.id}`;
    div.setAttribute(`data-id`, e.id);
    div.setAttribute('data-name', e.name);
    div.setAttribute('data-linked', e.id); 

    const span = document.createElement('span');
    span.textContent = e.name;

    const i = document.createElement('i');
    i.className = `far fa-trash-alt element-remove-${e.id}`;
    i.setAttribute('data-toggle', 'tooltip');
    i.setAttribute('data-placement', 'bottom');
    i.setAttribute('title', `Remove ${e.name}`);

    div.appendChild(span);
    if ( accessType != 'R' ) {
      div.appendChild(i);
    }
    container.appendChild(div);

    removePartnerCustomerAccess(`.element-remove-${e.id}`, e.id);
  });

  data.length = 0;
}